const inputs = {
  baseStyle: {},
  variants: {},
}

export default inputs;